import { inject } from "@angular/core";
import { toSignal } from "@angular/core/rxjs-interop";
import { ActivatedRoute, Router } from "@angular/router";
import { map } from "rxjs";

export function queryParam(key: string) {
  const route = inject(ActivatedRoute);
  const router = inject(Router);

  const value = toSignal(route.queryParamMap.pipe(map(p => p.get(key))));

  return Object.assign(value, {
    set(v: unknown) {
      router.navigate([], {
        relativeTo: route,
        queryParams: { [key]: v },
        queryParamsHandling: 'merge',
      });
    },
  });
}

export const numberParser = (s: string): number | undefined => {
  const n = Number(s);
  return s.trim() && !isNaN(n) ? n : undefined;
};

export function queryParamArray<T = string>(
  key: string,
  parse: (s: string) => T | undefined = s => s as T,
) {
  const route = inject(ActivatedRoute);
  const router = inject(Router);

  const value = toSignal(
    route.queryParamMap.pipe(
      map(p => (p.get(key)?.split(',') ?? []).map(parse).filter(v => v !== undefined)),
    ),
    { initialValue: [] as T[] },
  );

  return Object.assign(value, {
    set(v: unknown[]) {
      router.navigate([], {
        relativeTo: route,
        queryParams: { [key]: v.length ? v.join(',') : null },
        queryParamsHandling: 'merge',
      });
    },
  });
}
